import styled from '@emotion/styled/macro';

const ErrorMessageBar = styled.div`
  z-index: 10;
  width: 100%;
  height: 60px;
  color: #FFF;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.56;
  background: #9f0000;
`

export default ErrorMessageBar